import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'stripHtml',
  pure: true
})
export class StripHtmlPipe implements PipeTransform {

  private parser = new DOMParser();

  transform(value: string | null | undefined): string {
    if (!value) {
      return '';
    }

    const doc = this.parser.parseFromString(value, 'text/html');

    // vezmeme všechny elementy a přidáme za ně mezeru
    const elements = doc.body.querySelectorAll('*');

    elements.forEach(el => {
      el.insertAdjacentText('afterend', ' ');
    });

    return (doc.body.textContent || '')
      .replace(/\s+/g, ' ')
      .trim();
  }
}
